<template>
    <TimeRangeSelector v-model="range" :min="min" :max="max" :step="step" :min-range="minRange" :years="years"
        :aria-label="props.option.label" :emit-on-drag="false" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { TimeRangeSelector } from 'gertrud';
import { TimeRangeRequestOptionsItem } from 'atlas-shared/dist/RequestOptions';

const props = withDefaults(defineProps<{
    option: TimeRangeRequestOptionsItem;
    /** The full request settings object (needed to read/write timeRangeEarliest/timeRangeLatest). */
    settings: Record<string, any>;
    modelValue?: any;
}>(), {
    settings: () => ({}),
    modelValue: undefined,
});

const emit = defineEmits<{
    'update:modelValue': [value: { timeRangeEarliest: number; timeRangeLatest: number }];
}>();

const min = computed(() => props.option.min ?? 1900)
const max = computed(() => props.option.max ?? 2025)
const step = computed(() => props.option.step ?? 1)
const minRange = computed(() => props.option.minRange ?? 0)
const years = computed(() => props.option.years ?? [])

const range = computed({
    get: () => ({
        start: props.settings.timeRangeEarliest ?? min.value,
        end: props.settings.timeRangeLatest ?? max.value,
    }),
    set: (val) => emit('update:modelValue', {
        timeRangeEarliest: val.start,
        timeRangeLatest: val.end,
    }),
});
</script>